import ApplePass from 'components/apple-pass'
import GooglePass from 'components/google-pass'
import { useAuth } from 'context/auth'
import { useDesign } from 'context/design'
import { PASS_VIEW } from 'enums'
import React, { useState } from 'react'
import { generateDefaultStripImage, generateDefaultLogoImage } from 'utils'

function PassPreview({ children, view, values }) {
  const [showPass, setShowPass] = useState(true)
  const { currentUser } = useAuth()
  const { design, loading } = useDesign()

  let currentDesign = {}
  const passType = view || values?.passType

  const getDesign = (values = {}) => {
    const organizationName = currentUser?.account?.organisationName || ''
    const orgBranding = currentUser?.account?.branding || {}
    const backgroundColor =
      values.backgroundColor ||
      design?.backgroundColor ||
      orgBranding.pageBackgroundColor ||
      '#FF5E36'

    const stripImage =
      values.stripImage && values.stripImage.trim()
        ? values.stripImage
        : design?.stripImage ||
          orgBranding.backgroundImage ||
          orgBranding.coverImage ||
          currentUser?.account?.backgroundImage ||
          currentUser?.account?.coverImage ||
          generateDefaultStripImage(organizationName, backgroundColor)
    const logoImage =
      values.logoImage && values.logoImage.trim()
        ? values.logoImage
        : design?.logoImage ||
          orgBranding.topHeaderImage ||
          orgBranding.faviconImage ||
          orgBranding.logoImage ||
          currentUser?.account?.logo ||
          generateDefaultLogoImage(organizationName, backgroundColor)

    const fullName =
      values.fullName ||
      `${values.firstName || currentUser?.firstName || ''} ${values.lastName || currentUser?.lastName || ''}`.trim()

    return {
      backgroundColor,
      logoImage,
      stripImage,
      fullName: fullName || 'Anonymous',
      title: values.title || values.designation || values.description || values.jobTitle || values.role || '',
      points: values.points || 0,
      passCode: values.passCode || 'pa******',
      organisationName: organizationName,
      firstName: values.firstName || currentUser?.firstName || '',
      lastName: values.lastName || currentUser?.lastName || '',
      email: values.email || currentUser?.email || '',
      phone: values.phone || currentUser?.phone || '',
      customFields: values.customFields || [],
    }
  }

  if (values) currentDesign = getDesign(values)
  else currentDesign = getDesign(design || {})

  return (
    !loading && (
      <div style={{ width: '330px' }}>
        {/* <div
          onClick={() => setShowPass(!showPass)}
          className='tw-flex tw-mb-2 md:tw-hidden tw-justify-center'
        >
          <div className='tw-border tw-border-black tw-py-[8px] tw-px-[20px] tw-rounded-[4px] tw-flex tw-items-center tw-gap-[7px] tw-cursor-pointer tw-text-[15px]'>
            <EyeIcon />
            View card
          </div>
        </div> */}
        {/* design={values || formik?.values || currentDesign} */}
        <div className={showPass ? 'tw-block' : 'tw-hidden md:tw-block'}>
          {passType == PASS_VIEW.APPLE ? (
            <ApplePass design={currentDesign} />
          ) : (
            <GooglePass design={currentDesign} />
          )}

          {children}
        </div>
      </div>
    )
  )
}

export default PassPreview
